import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const tournamentJoin = createAsyncThunk(
  "tournamentJoin/tournamentJoin",
  async (payload, thunkAPI) => {
    try {
      const response = await api.post("join-tournament", payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const tournamentJoinSlice = createSlice({
  name: "tournamentJoin",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(tournamentJoin.pending, (state) => {
        state.loading = true;
      })
      .addCase(tournamentJoin.fulfilled, (state, action) => {
          
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(tournamentJoin.rejected, (state, action) => {
        
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default tournamentJoinSlice.reducer;
